import script from "./HelpDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpDialog.vue?vue&type=script&setup=true&lang=js"

import "./HelpDialog.vue?vue&type=style&index=0&id=19588aed&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19588aed"]])

export default __exports__